import { useState } from 'react'

export function useCurrency() {
  // Always show Argentine pesos for this product
  const [symbol] = useState('$')
  return symbol
}
